import React from 'react';
import { useTranslation } from 'react-i18next';
import EmptyState from "../../jo-components/misc/emptyState/emptyState";
import Message from "../../resale/seller/components/message";
import ItemCardInfos from "../../jo-components/cards/itemCard/components/itemCardInfos/itemCardInfos";
import ItemCard from '../../jo-components/cards/itemCard/itemCard';

export function WaitingTicketsList({ config, onSubmit=()=>{}, storage }) {
    const { t } = useTranslation();
    const messages = config['messages'];
    const waitingTickets = config['waiting_tickets_list'];

    const getMainAction = React.useCallback((item) => {
        if (!item?.actions?.length) return null;
        const hasWaitingListMenu = item.actions.find(action => action.type === 'WaitingListMenuStep' && action.enabled);
        if (hasWaitingListMenu)
            return {
                label: t('widget.button.manage.default_label'),
                icon: "arrowRight",
                enabled: true,
                onClick: () => {onSubmit({
                    data: {
                        action: 'WaitingListMenuStep',
                        waiting_list_ticket_id: item.id
                    }
                })}
            }
        return null;
    }, [onSubmit]);

    return (
        <div className={'wz-waiting-list'}>
            {messages?.length > 0 && messages?.map((message, index) => (
                <Message key={index} description={message.subtitle} {...message} />
            ))}
            {waitingTickets?.length > 0 ? (
                waitingTickets.map((subscription, index) => (
                    <ItemCard
                        key={index}
                        withMargin={false}
                        status={subscription.status}
                        title={subscription.rate_name}
                        subtitle={subscription.event_name}
                        action={getMainAction(subscription)}
                    >
                        <ItemCardInfos title={subscription.informations_title} informations={subscription.informations} />
                    </ItemCard>
                ))
            ) : (
                <EmptyState
                    icon='group'
                    title={t('widget.empty.subscriptions.title')}
                    subtitle={t('widget.empty.subscriptions.subtitle')}
                />
            )}
        </div>
    );
}